import { createAction, props } from "@ngrx/store";

export const getServerSentEventsToOrders = createAction(
    '[Server Sent Events] Orders',
);

export const getServerSentEventsToRidersLocations = createAction(
    '[Server Sent Events] Riders Locations',
);

export const getServerSentEventsToRidersLocationsSuccess = createAction(
    '[Server Sent Events] Riders Locations Success',
    props<{ data: any }>()
);

export const getServerSentEventsToOrdersSuccess = createAction(
    '[Server Sent Events] Orders Success',
    // props<{ data: any }>()
);

export const getServerSentEventsToOrdersFailure = createAction(
    '[Server Sent Events] Orders Failure',
    props<{ error: any }>()
);

export const getServerSentEventsToRidersLocationsFailure = createAction(
    '[Server Sent Events] Riders Locations Failure',
    props<{ error: any }>()
);

export const getServerSentEventsToRider = createAction(
    '[Server Sent Events] Rider',
);

export const getServerSentEventsToRiderSuccess = createAction(
    '[Server Sent Events] Rider Success',
    props<{ data: any }>()
);

export const getServerSentEventsToRiderFailure = createAction(
    '[Server Sent Events] Rider Failure',
    props<{ error: any }>()
);